'use client';

import { c as _c } from "react/compiler-runtime";
import { useToast } from '@common/hooks';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthMutation, COMMENT_STATUS } from '@/api';
import { invalidateExceptCommentLists, patchCommentInAllLists, reconcileCommentListsAfterChange } from './commentListSync';
interface UseDeleteCommentMutationOptions {
  onDeleteSuccess?: () => void;
}

// 댓글 삭제 후 목록 낙관 반영과 관련 캐시 정리를 담당하는 공통 훅이다.
export const useDeleteCommentMutation = options => {
  const $ = _c(10);
  const {
    toast,
    toastError
  } = useToast();
  const queryClient = useQueryClient();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = AuthMutation["put:/wello/v2/auth/wello-comment/{welloCommentId}/delete"]();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== toastError) {
    t1 = error => {
      toastError({
        error
      });
    };
    $[1] = toastError;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== options || $[4] !== queryClient || $[5] !== toast) {
    t2 = (_, t3) => {
      const {
        path
      } = t3;
      options?.onDeleteSuccess?.();
      toast({
        type: "success",
        message: "\uB313\uAE00\uC774 \uC0AD\uC81C\uB418\uC5C8\uC2B5\uB2C8\uB2E4."
      });
      const {
        welloCommentId
      } = path;
      patchCommentInAllLists(queryClient, welloCommentId, {
        commentStatusCd: COMMENT_STATUS.DELETED
      });
      invalidateExceptCommentLists(queryClient);
      reconcileCommentListsAfterChange({
        queryClient,
        commentId: welloCommentId,
        checkReflected: _temp
      });
    };
    $[3] = options;
    $[4] = queryClient;
    $[5] = toast;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = {
      ...t0,
      onError: t1,
      onSuccess: t2
    };
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return useMutation(t3);
};
function _temp(comment) {
  return !comment || comment.commentStatusCd === COMMENT_STATUS.DELETED;
}